var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUrgencia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3305_7973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99935 1.16602C10.2211 1.16602 12.8327 3.7776 12.8327 6.99935C12.8327 10.2211 10.2211 12.8327 6.99935 12.8327C3.7776 12.8327 1.16602 10.2211 1.16602 6.99935C1.16602 3.7776 3.7776 1.16602 6.99935 1.16602ZM6.99935 8.74935C6.84464 8.74935 6.69627 8.81081 6.58687 8.9202C6.47747 9.0296 6.41602 9.17797 6.41602 9.33268C6.41602 9.48739 6.47747 9.63577 6.58687 9.74516C6.69627 9.85456 6.84464 9.91602 6.99935 9.91602C7.15406 9.91602 7.30243 9.85456 7.41183 9.74516C7.52122 9.63577 7.58268 9.48739 7.58268 9.33268C7.58268 9.17797 7.52122 9.0296 7.41183 8.9202C7.30243 8.81081 7.15406 8.74935 6.99935 8.74935ZM6.99935 3.49935C6.85647 3.49937 6.71857 3.55182 6.6118 3.64677C6.50503 3.74171 6.43682 3.87254 6.4201 4.01443L6.41602 4.08268V7.58268C6.41618 7.73136 6.47311 7.87437 6.57518 7.98248C6.67724 8.09059 6.81674 8.15565 6.96516 8.16437C7.11359 8.17308 7.25974 8.12479 7.37375 8.02936C7.48777 7.93393 7.56104 7.79857 7.5786 7.65093L7.58268 7.58268V4.08268C7.58268 3.92797 7.52122 3.7796 7.41183 3.6702C7.30243 3.56081 7.15406 3.49935 6.99935 3.49935Z",
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3305_7973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUrgencia);
export default __webpack_public_path__ + "static/media/IconUrgencia.6ec78e8b77610110476b926c117dd424.svg";
export { ForwardRef as ReactComponent };